import { render } from "./Main.vue?vue&type=template&id=ed0a6d84&scoped=true&ts=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=ed0a6d84&lang=css&scoped=true"

import exportComponent from "/root/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed0a6d84"]])

export default __exports__